// extracted by mini-css-extract-plugin
export default {"body_styleDefault":"c-a_fr","body_styleRed":"c-a_fs"};